// extracted by mini-css-extract-plugin
export default {"main":"contact_main__6d367","title":"contact_title__6p5AC","backBlock":"contact_backBlock__9X5vM"};